"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.activateScripts = exports.scriptConsent = exports.removeLocal = exports.setLocal = exports.getLocal = exports.removeCookie = exports.setCookie = exports.getCookie = void 0;
const utils_1 = require("@obvio/utils");
const cookie_1 = require("cookie");
const constants_1 = require("../constants");
const env_1 = require("../env");
const getCookie = (key, req) => { var _a; return (_a = (env_1.IS_SERVER ? req === null || req === void 0 ? void 0 : req.cookies : (0, cookie_1.parse)(document.cookie))) === null || _a === void 0 ? void 0 : _a[key]; };
exports.getCookie = getCookie;
const setCookie = (key, value, res) => {
    var _a;
    const opts = typeof value === 'string' ? { value } : value;
    const cookie = (0, cookie_1.serialize)(key, (_a = opts.value) !== null && _a !== void 0 ? _a : '', (0, utils_1.exclude)(Object.assign(Object.assign({ secure: (0, env_1.getHomeUrl)().startsWith('https://'), path: '/', domain: (0, env_1.getDomain)() }, (0, utils_1.omit)(opts, 'ttl', 'delete')), (opts.ttl
        ? { maxAge: (0, utils_1.parseTime)(opts.ttl) / 1000 }
        : opts.delete
            ? { expires: new Date(0) }
            : {})), undefined));
    if (!env_1.IS_SERVER) {
        document.cookie = cookie;
    }
    else if (res) {
        const headers = res.getHeaders();
        const setCookieHeaders = headers['set-cookie'];
        const cookiesValues = Array.isArray(setCookieHeaders)
            ? setCookieHeaders.map(String)
            : setCookieHeaders
                ? [String(setCookieHeaders)]
                : [];
        res.setHeader('Set-Cookie', [...cookiesValues, cookie]);
    }
};
exports.setCookie = setCookie;
const removeCookie = (key, res) => {
    (0, exports.setCookie)(key, { delete: true }, res);
};
exports.removeCookie = removeCookie;
const getLocal = (key, sessionStorage) => {
    const value = !env_1.IS_SERVER &&
        window[sessionStorage ? 'sessionStorage' : 'localStorage'].getItem(key);
    if (!value) {
        return;
    }
    return JSON.parse(value);
};
exports.getLocal = getLocal;
const setLocal = (key, value, sessionStorage) => {
    if (env_1.IS_SERVER) {
        return false;
    }
    window[sessionStorage ? 'sessionStorage' : 'localStorage'].setItem(key, JSON.stringify(value));
    return true;
};
exports.setLocal = setLocal;
const removeLocal = (key) => {
    if (env_1.IS_SERVER) {
        return false;
    }
    window.localStorage.removeItem(key);
    return true;
};
exports.removeLocal = removeLocal;
function scriptConsent(type, cookie) {
    return (cookie === null || cookie === void 0 ? void 0 : cookie.includes(type))
        ? {}
        : { type: 'text/plain', 'data-consent-type': type };
}
exports.scriptConsent = scriptConsent;
function activateScripts() {
    var _a;
    if (typeof document !== 'undefined') {
        (_a = (0, exports.getCookie)(constants_1.COOKIE_CONSENT)) === null || _a === void 0 ? void 0 : _a.split(',').forEach((type) => {
            document
                .querySelectorAll(`script[data-consent-type="${type}"]`)
                .forEach((script) => {
                var _a;
                if (script.type === 'text/plain') {
                    const newScript = document.createElement('script');
                    ['innerHTML', 'async', 'src'].forEach((prop) => {
                        if (script[prop]) {
                            (0, utils_1.set)(newScript, prop, script[prop]);
                        }
                    });
                    (_a = script.parentNode) === null || _a === void 0 ? void 0 : _a.replaceChild(newScript, script);
                }
            });
        });
    }
}
exports.activateScripts = activateScripts;
